/**
 * Central config for all partner logos, links, and display names.
 * hoverRing: Tailwind ring color suffix, e.g. 'purple' -> hover:ring-purple-500
 */

export const PARTNERS = {
  HKU_CC: {
    id: 'hku-cc',
    name: 'HKU CC',
    displayName: 'HKU Common Core Office',
    link: 'https://commoncore.hku.hk',
    logo: '/asset/icons/partners/HKU-CC.png',
    logoClass: 'h-24 w-auto object-contain mb-4 px-16',
    hoverRing: 'purple',
    isInternal: false,
  },
  MCN: {
    id: 'mcn',
    name: 'MCN',
    displayName: 'Millennium Campus Network',
    link: 'https://www.mcnpartners.org',
    logo: '/asset/icons/partners/Millennium.avif',
    logoClass: 'h-24 w-auto object-contain mb-4 px-16',
    hoverRing: 'blue',
    isInternal: false,
  },
  MCN_UNAI: {
    id: 'mcn-unai',
    name: 'MCN & UNAI',
    displayName: 'Millennium Campus Network & United Nations Academic Impact',
    link: 'https://www.mcnpartners.org',
    logo: '/asset/icons/partners/Millennium.avif',
    logoClass: 'h-20 w-auto object-contain mb-3',
    hoverRing: 'blue',
    isInternal: false,
  },
  TITAN: {
    id: 'titan',
    name: 'TITAN',
    displayName: 'Transdisciplinary Initiative for Talents and Innovators',
    link: '/titan',
    logo: '/asset/icons/TITAN_Logo_Original.svg',
    logoClass: 'h-20 w-auto object-contain mb-3',
    hoverRing: 'orange',
    isInternal: true,
  },
  GERHUB: {
    id: 'gerhub',
    name: 'GerHub',
    displayName: 'GerHub',
    link: 'https://www.gerhub.org',
    logo: '/asset/icons/partners/GerHub.jpg',
    logoClass: 'h-24 w-auto object-contain mb-4',
    hoverRing: 'orange',
    isInternal: false,
  },
  MAGIC_LAND: {
    id: 'magic-land',
    name: 'Magic Land',
    displayName: 'Magic Land',
    link: 'https://www.magiclandmongolia.mn/mn',
    logo: '/asset/icons/partners/MagicLand.jpeg',
    logoClass: 'h-24 w-auto object-contain mb-4',
    hoverRing: 'pink',
    isInternal: false,
  },
  NUUDELCH_ZUSLAN: {
    id: 'nuudelch-zuslan',
    name: 'Nuudelch Zuslan',
    displayName: 'Nuudelch Zuslan',
    link: 'https://www.instagram.com/nuudelch.zuslan/',
    logo: '/asset/icons/partners/NuudelchZuslan.jpg',
    logoClass: 'h-24 w-auto object-contain mb-4',
    hoverRing: 'green',
    isInternal: false,
  },
};

/** Keys for PromotionalHome – Student Learning Partner row */
export const STUDENT_LEARNING_PARTNER_KEYS = ['HKU_CC'];

/** Keys for PromotionalHome – Supporting Organisations row */
export const SUPPORTING_ORG_KEYS = ['MCN'];

/** Keys for PromotionalHome – Mongolia Critical Zone partnering NGOs */
export const MONGOLIA_PARTNER_KEYS = ['GERHUB', 'MAGIC_LAND', 'NUUDELCH_ZUSLAN'];

/** Keys for Conference2026 Our Partners */
export const CONFERENCE_2026_PARTNER_KEYS = ['MCN_UNAI', 'HKU_CC', 'TITAN'];

/** Keys for MongolianCriticalZone Our Partners */
export const MONGOLIAN_CRITICAL_ZONE_PARTNER_KEYS = ['GERHUB', 'MAGIC_LAND', 'NUUDELCH_ZUSLAN'];

const HOVER_RING_CLASSES = {
  purple: 'hover:ring-purple-500',
  blue: 'hover:ring-blue-500',
  orange: 'hover:ring-orange-500',
  green: 'hover:ring-green-500',
  pink: 'hover:ring-pink-500',
};

/** Resolve hover ring class from key */
export const getHoverRingClass = (hoverRing) =>
  HOVER_RING_CLASSES[hoverRing] || HOVER_RING_CLASSES.blue;

/** Get partner list by config keys */
export const getPartnersByKeys = (keys) =>
  keys.map((key) => PARTNERS[key]).filter(Boolean);
